import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-toast-alerts',
  template: `
    <fl-toast-alert-container class="mobile:show ToastAlertOverlay" />
    <fl-toast-alert-container
      class="mobile:hide"
      [flSticky]="true"
      [flStickyStatic]="true"
    />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastAlertsComponent {}
